import { useContext, useMemo } from 'react'
import { NavigatorContext } from '../navigator-context'

export const useParams = (pageKeyProp) => {
	const { activeRoute } = useContext(NavigatorContext);
	const pageKeys = useMemo(() => {
		return typeof pageKeyProp === 'string' ? [pageKeyProp] : (pageKeyProp || []);
	}, [pageKeyProp])
	const params = useMemo(() => {
		return pageKeys.includes(activeRoute?.key) ? activeRoute.match?.params : {};
	}, [activeRoute, pageKeys])

	return params;
}